import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.resources')
  .factory('$resourceAllocationsInstances', ResourceAllocationsInstancesFactory);

function ResourceAllocationsInstancesFactory($bringozFactory: $bringozFactory,
                                    resourcesAllocationsInstancesApi: BringozApi,
                                    ResourceAllocations_DS: DataStoreConfig) {

  function $resourceAllocationsInstances(id: string) {
    return $bringozFactory(id, resourcesAllocationsInstancesApi, ResourceAllocations_DS)
  }
  return $resourceAllocationsInstances
}
